import { getLocation } from './location';

/* ========================================================================= */
/* Location and URL */
/* ========================================================================= */

/**
 * @function isLocalURL
 * @param {string} url URL to analyse
 * @param {string} origin Site's origin
 * @return {boolean}
 *
 * Detects whether a given url is local to the given origin.
 * 1. Passing an invalid URL to the URL constructor will throw.
 */
export const isLocalURL = (url, origin = getLocation()?.origin) => {
    if (url.startsWith('/') || url.startsWith('#') || url.startsWith('?')) {
        return true;
    }

    try {
        const resolved = new URL(url, origin); /* [1] */
        return resolved.origin === origin;
    } catch (_) {
        return false;
    }
};
